import { IAlarmByVendorFilter, IAlarmFilter } from '@interfaces/alarms/alarm';
import { TEmptyObject } from '@interfaces/common/common';

import { EVendorsValues } from '@enums/common';

import { useQueryFlexidasAlarmFilters } from './useQueryFlexidasAlarmFilters';
import { useQueryLimenetAlarmFilters } from './useQueryLimenetAlarmFilters';
import { useQueryOranAlarmFilters } from './useQueryOranAlarmFilters';

const getAlarmsFilters = ({
	flexidas,
	limenet,
	oran,
	vendor,
}: {
	flexidas: IAlarmByVendorFilter;
	limenet: IAlarmByVendorFilter;
	oran: IAlarmByVendorFilter;
	vendor: string;
}): TEmptyObject | IAlarmByVendorFilter => {
	switch (vendor) {
		case EVendorsValues.flexidas:
			return flexidas;
		case EVendorsValues.limenet:
			return limenet;
		case EVendorsValues.oran:
			return oran;
		default:
			return {};
	}
};

interface IUseAlarmManagementFiltersReturned {
	filtersList: IAlarmFilter[];
	isLoadingFilters: boolean;
}

export const useAlarmManagementFilters = (vendor: string): IUseAlarmManagementFiltersReturned => {
	const limenet = useQueryLimenetAlarmFilters(vendor);
	const flexidas = useQueryFlexidasAlarmFilters(vendor);
	const oran = useQueryOranAlarmFilters(vendor);

	const { filters = [], isLoading = false } = getAlarmsFilters({
		flexidas,
		limenet,
		oran,
		vendor,
	});

	return {
		filtersList: filters,
		isLoadingFilters: isLoading,
	};
};
